import { render, staticRenderFns } from "./RegistrationMasukanOtpView.vue?vue&type=template&id=f548c62a&scoped=true"
import script from "./RegistrationMasukanOtpView.vue?vue&type=script&lang=js"
export * from "./RegistrationMasukanOtpView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f548c62a",
  null
  
)

export default component.exports